// extracted by mini-css-extract-plugin
export default {"leftSideBtn":"ViewButtons_leftSideBtn__z2QDP","leftSideBtnContainer":"ViewButtons_leftSideBtnContainer__M1RQV","rightSideBtn":"ViewButtons_rightSideBtn__b3F5+"};